import Link from 'next/link';

export const SummitHeader = () => {
  return (
    <header className="py-[34px] top-0 fixed z-50 w-screen">
      <div className="container">
        <Link
          href="/"
          aria-label="Go back home"
          className="max-w-max inline-block focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-neutral-500 focus-visible:outline-1"
        >
          <svg
            className="w-6 lg:w-8"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_5144_7257)">
              <path d="M16 32L0 16H16V32Z" fill="url(#paint0_linear_5144_7257)" />
              <path d="M32 32L0 0H32V32Z" fill="url(#paint1_linear_5144_7257)" />
              <path d="M8 32L0 24H8V32Z" fill="url(#paint2_linear_5144_7257)" />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_5144_7257"
                x1="8"
                y1="6.87059"
                x2="8.00001"
                y2="44.2578"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.259114" stopColor="#888888" />
                <stop offset="0.511791" stopColor="white" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_5144_7257"
                x1="16"
                y1="-18.2588"
                x2="16"
                y2="56.5156"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.259114" stopColor="#888888" />
                <stop offset="0.511791" stopColor="white" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_5144_7257"
                x1="4"
                y1="19.4353"
                x2="4"
                y2="38.1289"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0.259114" stopColor="#888888" />
                <stop offset="0.511791" stopColor="white" />
              </linearGradient>
              <clipPath id="clip0_5144_7257">
                <rect width="32" height="32" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </Link>
      </div>
    </header>
  );
};
